
export function toUppercase() {
    return {
        update(el) {
            //transforma todas as letras em maiusculas e remove acentuações.
            el.value = el.value
                .toUpperCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/['"^~´`]+/g, "");
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/directives.js